import { render, staticRenderFns } from "./Forgot-password-form.vue?vue&type=template&id=696f86d1&scoped=true"
import script from "./Forgot-password-form.vue?vue&type=script&lang=js"
export * from "./Forgot-password-form.vue?vue&type=script&lang=js"
import style0 from "./Forgot-password-form.vue?vue&type=style&index=0&id=696f86d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696f86d1",
  null
  
)

export default component.exports